module.exports = __webpack_public_path__ + "img/icon-result-4.5650d56b.svg";